@if (currentOrganization(); as organization) {
  @let avatar = organization.avatar;
  @let name = organization.name;
  <evc-avatar
    [avatar]="avatar"
    size="lg"></evc-avatar>
  <span class="name">
    {{ name ?? 'labels.org_not_found' | translate }}
  </span>
}
